import styled from "styled-components";

export default styled.a`
    text-decoration: none;
`;
